import React from 'react';
import PropTypes from 'prop-types';

//import cookieConsentStore from 'app/components/cookieConsent/store';

import { is } from '../../utils';
import Form from '../Form';

export const MISSING_RESTAURANT_NAME_ERROR = i18n.gettext(
  "Please provide your restaurant's name."
);

export const RESTAURANT_NAME_TOO_LONG_ERROR = i18n.gettext(
  "Your restaurant's name is too long. (max. 1024 chars)"
);

export const MISSING_RESTAURANT_ADDRESS_ERROR = i18n.gettext(
  "Please provide your restaurant's address."
);

export const PHONE_ERROR = i18n.gettext('Please provide a valid phone number.');

export const INVALID_RESTAURANT_WEBSITE_ERROR = i18n.gettext(
  'Please provide a valid URL.'
);

export const MISSING_FIRST_NAME_ERROR = i18n.gettext(
  'Please provide your first name.'
);

export const MISSING_LAST_NAME_ERROR = i18n.gettext(
  'Please provide your last name.'
);

export const MISSING_EMAIL_ERROR = i18n.gettext(
  'Please provide your email address.'
);

export const INVALID_EMAIL_ERROR = i18n.gettext(
  'Please provide a valid email address.'
);

const initialValues = {
  city: '',
  country: '',
  email: '',
  facility_name: '',
  first_name: '',
  google_places_id: '',
  last_name: '',
  newsletter_subscribe: false,
  notification_phone: '',
  phone: '',
  state: '',
  street: '',
  terms_of_service_accepted: false,
  website: '',
  zip_code: '',
};

function transform(values) {
  return {
    ...values,
    website:
      values.website &&
      (/^(https?|ftp):\/\//.test(values.website)
        ? values.website
        : `https://${values.website}`),
  };
}

function validate(values) {
  const errors = {};
  if (is.empty(values.email)) {
    errors.email = MISSING_EMAIL_ERROR;
  } else if (!is.email(values.email)) {
    errors.email = INVALID_EMAIL_ERROR;
  }
  if (
    !is.empty(values.phone) &&
    !window.intlTelInputUtils?.isValidNumber(values.phone)
  ) {
    errors.phone = PHONE_ERROR;
  }
  if (
    is.empty(values.notification_phone) ||
    !window.intlTelInputUtils?.isValidNumber(values.notification_phone)
  ) {
    errors.notification_phone = PHONE_ERROR;
  }
  if (!is.empty(values.website) && !is.url(values.website)) {
    errors.website = INVALID_RESTAURANT_WEBSITE_ERROR;
  }
  if (is.empty(values.facility_name)) {
    errors.facility_name = MISSING_RESTAURANT_NAME_ERROR;
  }
  if (values.facility_name.trim().length > 1024) {
    errors.facility_name = RESTAURANT_NAME_TOO_LONG_ERROR;
  }
  if (is.empty(values.first_name)) {
    errors.first_name = MISSING_FIRST_NAME_ERROR;
  }
  if (is.empty(values.last_name)) {
    errors.last_name = MISSING_LAST_NAME_ERROR;
  }
  if (is.empty(values.google_places_id)) {
    errors.google_places_id = MISSING_RESTAURANT_ADDRESS_ERROR;
  }
  if (!values.terms_of_service_accepted) {
    errors.terms_of_service_accepted = 'PLACEHOLDER';
  }
  return errors;
}

function SignupForm({ children }) {
  return (
    <Form
      initialValues={initialValues}
      validate={validate}
      transform={transform}
      // onSubmit={() => {
      //   if (window.ga && cookieConsentStore.consents.includes('marketing')) {
      //     window.ga('send', 'event', 'signuppage', 'signup', '/signin/');
      //   }
      // }}
    >
      {children}
    </Form>
  );
}

SignupForm.propTypes = {
  children: PropTypes.node,
};

export default SignupForm;
